import { useMedia } from 'src/uses/media'
const media = useMedia()

// Models
export type TAnswer = {
  id?: string// NOTE: question id
  text: string[] | string
  value?: string[] | string
  custom?: string// NOTE: structure(特殊な回答)用 コンポーネント名をいれる
}

export type TQuestionInput = {
  id?: string
  text?: string
  value?: string
  checked?: boolean// NOTE: selectでもcheckboxでもcheckedに統一
  comment?: string// NOTE: 答えに対する返答
  disabled?: boolean
  exclusive?: boolean// NOTE: 排他処理、questions内で単一である必要がある
  emphasis?: boolean// NOTE: 強調フラグ
  iterator?: number
}

export type TBegin = {
  id?: string
  custom: string
}

export type TEnd = {
  id?: string
  custom: string
  data: any
}

export type THistory = {
  id: string
  type: 'question' | 'answer' | 'result' | 'begin' | 'end' | 'comment'
  data: TQuestion | TAnswer | TBegin | TEnd
}

export type TBody = {
  href: string
  src: string
}

export type TQuestion = {
  id?: string
  type?: 'checkbox' | 'select' | 'radio'
  isEntered?: boolean
  checkLimit?: number
  name?: string
  text?:string
  custom?: string// NOTE: 特殊な設問用 コンポーネント名をいれる customを使用する場合、typeは不要
  questions?: TQuestionInput[]

  questions2?: TQuestionInput[]// TODO: 見直す
  questions3?: TQuestionInput[]// TODO: 見直す
  url?: string
  image?: string
  toResult?: string
  alert?: string[]
  hasUseEffect?: boolean

  texts?: string[]
  data_id?: string// eslint-disable-line camelcase
  bodys?: TBody[][]
  brand_array?: any// eslint-disable-line camelcase
  positioning_map?: string// eslint-disable-line camelcase
  ec_banner_flg?: boolean
  shop_banner_flg?: boolean
  // dashboard_flg?: number
  // referrer_ec_flg?: number
}

export type TQuestionArray = {
  question_id: number// eslint-disable-line camelcase
  question_string: string// eslint-disable-line camelcase
  question_emphasis_flg?: boolean// eslint-disable-line camelcase
  question_exclusive_flg?: boolean// eslint-disable-line camelcase
}

export type TQuestionAnswers = {
  answer_id1?: string// eslint-disable-line camelcase
  answer_id2?: string// eslint-disable-line camelcase
  answer_id3?: string// eslint-disable-line camelcase
}

export type TResponse = {
  status?: string
  question_process_id?: string// eslint-disable-line camelcase
  question_type?: 'button' | 'checkbox' | 'structure'// eslint-disable-line camelcase
  form_id?: string// eslint-disable-line camelcase
  client_name?: string// eslint-disable-line camelcase
  display_string?: string[]// eslint-disable-line camelcase
  question_string?: string// eslint-disable-line camelcase
  question_array?: TQuestionArray[]// eslint-disable-line camelcase
  brand_array?: Array<any>// eslint-disable-line camelcase
  // repair_string?:number
  input_array?: Array<any>// eslint-disable-line camelcase
  errorCode?: number
  errorMessage?: string
  dashboard_flg?: number
  referrer_ec_flg?: number
}

export type TResult = {
  storageKey?: string
  clientNameKey?: string

  bodytype?: string[]
  isVisitedBodytype: boolean
  isVisitedOtherRec: boolean
  isVisitedQuestionnaire: boolean
  response: TResponse
  data?: any
}

export type TCookie = {
  [key: string]: {
    storageKey?: string
    expire?: number
  }
}

export type TModal = {
  isOpen: boolean
  type?: 'restart' | 'questionnairerequest' | 'shopcampaign'
  options?: {
    callback?: Function
  }
}

export type TStatus = {
  isShopCampaign: boolean
  isQuestionnaireRequest: boolean
  isQuestionnaireEnded: boolean
  isTalkStart: boolean
  isPrevResultStart: boolean
  isMaintenance: boolean
  isUnknowID: boolean
  showRestart: boolean
  prevResult?: string
  shopQR?: number
  referrerEC: number
}

export type TURLQuery = {
  [objkey: string]: {
    key: string
    value: string
  }
}

export type TCampaignShopList = {
  [key: string]: {
    label: string
    items: {
      label: string
    }[]
  }
}

export interface IInitialState {
  device: {
    media: 'pc' | 'sp' | null
  },
  status: TStatus,
  campaignShopList: TCampaignShopList,
  urlquery: TURLQuery,
  cookie: TCookie,
  result: TResult,
  questions: {},
  talk: {
    history: THistory[]
  },
  modal: TModal
}

// States
const initialState: IInitialState = {
  device: {
    media: (media.sp as any).matches ? 'sp' : 'pc'
  },
  status: {
    isShopCampaign: false,// NOTE: 店頭連携フラグ ランディング時にmodalが立ち上がりリザルトエリアに店舗リストが表示される（trueにするときは最新の店舗リストを確認）
    isQuestionnaireRequest: true,
    isQuestionnaireEnded: false,
    isTalkStart: false,
    isPrevResultStart: false,
    isMaintenance: false,
    isUnknowID: false,
    showRestart: false,
    prevResult: '',
    shopQR: 0,
    referrerEC: 0
  },
  campaignShopList: {// NOTE: related isShopCampaign
    tokyo: {
      label: '東京都',
      items: [
        { label: `タイヤ館足立` },
        { label: `タイヤ館小松川` },
        { label: `コクピット豊洲` },
        { label: `タイヤ館池上` },
        { label: `コクピット21世田谷` },
        { label: `タイヤ館パドック246` },
        { label: `タイヤ館目白` },
        { label: `タイヤ館西荻窪` },
        { label: `タイヤ館板橋` },
        { label: `タイヤ館関越練馬` },
        { label: `タイヤ館三鷹` },
        { label: `タイヤ館調布` },
        { label: `タイヤ館府中` },
        { label: `タイヤ館小平` },
        { label: `タイヤ館めじろ台` },
        { label: `タイヤ館青梅` },
        { label: `タイヤ館保谷` },
        { label: `タイヤ館東久留米` },
        { label: `タイヤ館多摩センター` },
        { label: `タイヤ館稲城` },
        { label: `タイヤ館玉川上水` },
      ]
    },
  },
  urlquery: {
    shopcampaign: {
      key: 'shop_promotion01',
      value: '1'
    },
    ec: {
      key: 'ai_prm',
      value: '1,2'
    }
  },
  cookie: {
    questionnaireRequest: {// REFS: status.isQuestionnaireRequest
      storageKey: 'AICB_QUESTIONNAIRE_REQUEST_23Wi',
      expire: (60 * 1000 * 60 * 24) * 2
    }
  },
  result: {
    storageKey: 'AICB_PH2_UNIQUE_ID',
    clientNameKey: 'AICB_CLIENT_NAME',

    isVisitedBodytype: false,
    isVisitedOtherRec: false,
    isVisitedQuestionnaire: false,
    response: {}
  },
  questions: {},
  talk: {
    history: []
  },
  modal: {
    isOpen: false
  }
}

export default initialState
